import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import copy from "copy-to-clipboard"
import rgbHex from "rgb-hex"
import { withStyles } from "@material-ui/core/styles"
import { withSnackbar } from "notistack"

const styles = theme => ({
	root: {
		margin: theme.spacing ( 2 ),
		display: "flex",
		flexDirection: "column",
		width: 365,
		"&:hover": {
			boxShadow: theme.shadows [ 3 ]
		},
		[theme.breakpoints.down ("md")]: {
			width: "100%",
		}
	},
	name: {
		fontSize: "1rem",
		padding: `${theme.spacing ( 2 )}px ${theme.spacing ( 2 )}px 0`
	},
	content: {
		display: "flex",
		flexGrow: 1,
		flexWrap: "wrap",
		paddingBottom: `${theme.spacing ( 2 )}px !important`
	},
	swatch: {
		display: "flex",
		height: 100,
		width: "calc( 100% / 3 )",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer"
	}
})

class Color extends React.Component {

	constructor ( props ) {
		super ( props )
		this.state = {
			open: false
		}
	}

	normalizeColor ( color ) {
		if ( color.startsWith ("#") ) return color.toUpperCase ()
		return `#${rgbHex ( color ).toUpperCase ()}`
	}

	createSwatch ( color, contrastText ) {
		const { classes, enqueueSnackbar } = this.props
		return <div
			className={classes.swatch}
			style={{ backgroundColor: color }}
			onClick={ () => {
				copy ( this.normalizeColor ( color ) )
				this.setState ({ open: true })
				enqueueSnackbar ("Copied to clipboard!")
			}} >
			<span style={{ color: contrastText }} >
				{this.normalizeColor ( color )}
			</span>
		</div>
	}

	render () {
		const { classes, theme, name } = this.props
		const { open } = this.state
		const textColor = theme.palette [ name ].contrastText
		return <Card className={classes.root} elevation={1} >
			<Typography className={classes.name} variant="h6" >{name.toUpperCase ()}</Typography>
			<CardContent className={classes.content} >
				{this.createSwatch ( theme.palette [ name ].light, textColor )}
				{this.createSwatch ( theme.palette [ name ].main, textColor )}
				{this.createSwatch ( theme.palette [ name ].dark, textColor )}
			</CardContent>
		</Card>
	}

}

Color.propTypes = {
	classes: PropTypes.object.isRequired,
	enqueueSnackbar: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired
}

export default withSnackbar ( withStyles ( styles, { withTheme: true } ) ( Color ) )
